export function locateUser({ onSuccess, onError }) {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(
			({ coords }) => {
				onSuccess({
					latitude: coords.latitude,
					longitude: coords.longitude,
					locationSource: 'browser_geolocation',
				});
			},
			() => {
				if (onError) onError(new Error('Geolocation failed'));
			},
			{ timeout: 10000 }
		);
	} else {
		if (onError) onError(new Error('Geolocation not supported'));
	}
}
